export default function Description(props: {
  description: string | null | undefined;
}) {
  if (!props.description) {
    return null;
  }

  return <div className="text-secondary mt-1 small">{props.description}</div>;
}
